export const SUCCESS = 0
export const LOGIN_FAILED = 200001
export const USER_ALREADY_EXIST = 200003
export const INVALID_REGISTER_CODE = 200002
export const USER_NOT_EXIST = 200004
export const INVALID_CODE = 200005
export const NO_PERMISSION = 100001
export const PASSWORD_ERROR = 200001
export const PROJECT_ALREADY_EXIST = 300001
export const TAG_ALREADY_EXIST = 300003
export const CRAWLER_ALREADY_EXIST = 300005
export const CAN_NOT_DELETE = 300011
